
import qs from 'qs';

const baseValidator = {
  validate: async (response, request) => {
    const { allowStatus } = request.options;
    if (allowStatus) {
      return [200].concat(Array.isArray(allowStatus) ? allowStatus : [allowStatus]).includes(response.status);
    }
    return response.ok && response.status === 200;
  },
  onError: (response) => {
    throw response;
  }
}
const jsonValidator = {
  validate: async (response, request) => {
    try {
      response.resJson = await response.json();
      return true;
    } catch (err) {
      return false;
    }
  },
  onError: (response) => {
    throw response;
  }
}

const authValidator = {
  validate: async (response, request) => {
    const { errors = {} } = response.resJson || {};
    const { code } = errors;
    if (code === '00000012') {
    }
    return true;
  },
  onError: (response) => {
    throw response;
  }
}

const validate = async (res, req, validators) => {
  for (const validator of validators) {
    if (!await validator.validate(res, req)) {
      if (validator.onError) throw validator.onError(res);
    }
  }
}


async function request(url, options, validators) {
  options = options || {};
  options.headers = options.headers || {};
  options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/json';
  options.headers['Authorization'] = options.headers['Authorization'];


  const { allowStatus, loadingBlock = true, errorPopupBlock = false, ...fetchOption } = options;
  try {
    const res = await fetch(url, fetchOption);
    await validate(res, { url, options }, validators);
    return res;
  } catch (err) {
    throw (err);
    // return undefined;
  } finally {
  }
}

export const get = async (url, params = {}, options = undefined, validators = []) => {
  const method = 'GET';
  const query = Object.keys(params).length === 0 ? '' : qs.stringify(params);
  if (query) {
    url = `${url}${url.includes('?') ? '&' : '?'}${query}`;
  }
  return await request(url, { method, ...options || {} }, [baseValidator].concat(validators));
}

export const getJson = async ({ url, params = {}, options = undefined, validators = [], othersHeaders }) => {
  const headers = {
    'Content-Type': 'application/json',
    ...othersHeaders,
  };
  const res = await get(url, params, { headers, ...options }, [jsonValidator, authValidator].concat(validators));
  return res ? res.resJson : {};
}

export const post = async (url, params, options = undefined, validators = []) => {
  const method = 'POST';
  const res = await request(url, { ...options, method, body: params }, [baseValidator].concat(validators));
  return res
}

export const postJson = async ({ url, params, options = undefined, validators = [], othersHeaders }) => {
  const headers = {
    'Content-Type': 'application/json',
    ...othersHeaders
  };
  const res = await post(url, JSON.stringify(params), { headers, ...options }, [jsonValidator, authValidator].concat(validators))
  return res ? res.resJson : {}
}
export const put = async (url, params, options = undefined, validators = []) => {
  const method = 'PUT';
  const res = await request(url, { ...options, method, body: params }, validators);
  return res
}

export const putJson = async ({ url, params, options = undefined, validators = [], othersHeaders }) => {
  const headers = {
    'Content-Type': 'application/json',
    ...othersHeaders
  };
  const res = await put(url, JSON.stringify(params), { headers, ...options }, [baseValidator, jsonValidator, authValidator].concat(validators))
  return res ? res.resJson : {}
}
export const del = async (url, params, options = undefined, validators = []) => {
  const method = 'DELETE';
  const res = await request(url, { ...options, method, body: params }, validators);
  return res
}

export const delJson = async ({ url, params, options = undefined, validators = [], othersHeaders }) => {
  const headers = {
    'Content-Type': 'application/json',
    ...othersHeaders
  };
  const res = await del(url, JSON.stringify(params), { headers, ...options }, [baseValidator, jsonValidator, authValidator].concat(validators))
  return res ? res.resJson : {}
}
